module.exports = __webpack_public_path__ + "img/jifen8.5f1180b5.png";